import { render, staticRenderFns } from "./vSearch.vue?vue&type=template&id=a2bcdada&scoped=true&"
import script from "./vSearch.vue?vue&type=script&lang=js&"
export * from "./vSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bcdada",
  null
  
)

export default component.exports